var Backbone = require('backbone');
var _ = require('underscore');

var Page = require('front/pages/Page/Page');
var Section = require('front/pages/Section/Section');
var Utils = require('front/utils/Utils');

var MapStyle = require('front/components/Index/IndexMapStyle');

require('./Index.less');


var mapCenter = new google.maps.LatLng(56.7689749,60.7592701);

var mapPopup = new google.maps.LatLng(56.7677749,60.7592701);

var mapOptions = {
    center: mapCenter,
    zoom: 15,
    disableDoubleClickZoom: true,
    maxZoom: 22,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    scrollwheel: false,
    zoomControl: false,
    streetViewControl: false
};

function CustomMarker(latlng, map, args) {
    this.latlng = latlng;
    this.args = args;
    this.setMap(map);
}

CustomMarker.prototype = new google.maps.OverlayView();

CustomMarker.prototype.draw = function () {

    var self = this;

    var div = this.div;

    if (!div) {

        div = this.div = document.createElement('div');

        div.className = 'Index-mapPopup';

        $(div).append(app.data.mapPopupContent);

        var panes = this.getPanes();
        panes.overlayImage.appendChild(div);
    }

    var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

    if (point) {
        div.style.left = point.x + 'px';
        div.style.top = point.y + 'px';
    }
};

CustomMarker.prototype.remove = function () {
    if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
    }
};

CustomMarker.prototype.getPosition = function () {
    return this.latlng;
};



module.exports = Section.extend({

    title: 'Робот-художник • Рисуем картину вместе с вами',

    el: '.Index',

    events: {
        'click .Index-contestant--1 a': 'onMapClick'
    },

    onYouTubeIframeAPIReadyOld: undefined,

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onYouTubeIframeAPIReady', 'onYouTubePlayerReady', 'onVideoClick', 'onPlayerStateChange');

        Section.prototype.initialize.call(this, options);

        this.isMobile = $('html').hasClass('isMobile');
        this.$video = this.$('.Index-video');

        this.initMap();

        app.vent.on('scrollto', function (pos) {
            var top = undefined;

            if (pos == 'current') {
                top = this.$('.Index-current').offset().top - 100 + (this.isMobile ? 102 : 0);
            }

            if (pos == 'map') {
                top = this.$('.Index-map').offset().top - 220 + (this.isMobile ? 122 : 0);
            }

            if (top) {
                //http://stackoverflow.com/questions/8149155/animate-scrolltop-not-working-in-firefox
                $('body, html').animate({'scrollTop': top}, 700);
            }

        }.bind(this));

        //на девайсах надо спрятать контент индекса при показе попапа
        app.vent.on('gallery-popup-show', function (pos) {
            this.$el.addClass('Index--gallery-popup-visible');
        }.bind(this));

        app.vent.on('gallery-popup-hide', function (pos) {
            this.$el.removeClass('Index--gallery-popup-visible');
        }.bind(this));

        this.$player = this.$('.Index-video iframe');

        if (typeof window.onYouTubeIframeAPIReady === 'function') {
            this.onYouTubeIframeAPIReadyOld = window.onYouTubeIframeAPIReady;
        }

        window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;
    },

    onYouTubeIframeAPIReady: function () {

        if (this.onYouTubeIframeAPIReadyOld) {
            this.onYouTubeIframeAPIReadyOld.call(arguments);
        }
        this.player = new YT.Player(this.$player[0], {events:{onReady:this.onYouTubePlayerReady}});
    },

    onPlayerStateChange: function (event) {
        this.$video.toggleClass('Index-video--play', event.data == YT.PlayerState.PLAYING);
    },

    onYouTubePlayerReady: function () {

        this.player.addEventListener('onStateChange', this.onPlayerStateChange);

        if (!this.isMobile) {
            this.player.playVideo();
        }

        this.player.mute();
        this.player.setLoop(1);
    },

    onVideoClick: function (e) {
        e.preventDefault();
        this.$video.off('click', this.onVideoClick);
        this.player.playVideo();

        return false;
    },


    activate: function () {
        console.log('activate Index');

        if (this.isMobile) {
            this.$video.on('click', this.onVideoClick);
        }

        return Section.prototype.activate.call(this);
    },


    deactivate: function (params) {
        console.log('deactivate Index');

        this.$video.off('click', this.onVideoClick);

        return Section.prototype.deactivate.call(this, params);
    },


    render: function () {
        console.log('render Index');
        var result = Section.prototype.render.call(this);

        if (this.options.inAnimated) {
            this.$el.css({opacity: 0});
        }

        return result;
    },


    playIn: function (params) {
        console.log('playIn Index');

        var self = this;

        if (this.options.inAnimated) {
            return new Promise(function (resolve) {

                self.$el.css({opacity: 1});

                self.playInResolve = resolve;

                self.playInTimeout = setTimeout(function () {
                    delete self.playInTimeout;
                    resolve();
                }, 400);
            });
        } else {
            return Utils.createEmptyPromise();
        }
    },


    playOut: function (params) {
        console.log('playOut Index');

        if (this.playInTimeout) {
            clearTimeout(this.playInTimeout);
            this.playInResolve && this.playInResolve();
            delete this.playInTimeout;
            delete this.playInResolve;
        }

        var self = this;

        return new Promise(function (resolve) {
            self.$el.animate({opacity:0}, params.duration, function () {
                resolve();
            });
        });
    },


    initMap: function () {

        var options = mapOptions;

        if (this.isMobile) {
            options = _.extend(options, {
                scaleControl: false,
                draggable: false
            });
        }

        this.$mapContainer = this.$('.Index-mapContainer');
        if (!this.$mapContainer.size()) {
            return;
        }

        this.map = new google.maps.Map(this.$('.Index-mapContainer')[0], mapOptions);

        this.map.mapTypes.set('map_style', MapStyle);
        this.map.setMapTypeId('map_style');

        var overlay = new CustomMarker(
            mapPopup,
            this.map,
            {}
        );
    },


    onMapClick: function () {
        app.vent.trigger('scrollto', 'map');
    }


});




//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Index/Index.js
// module id = 34
// module chunks = 0